module.exports = __webpack_public_path__ + "img/logo_medium_yellow_white.5a4463d1.svg";